import useMediaQueryMui from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useIsMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQueryMui(theme.breakpoints.down('xs'));
  return isMobile;
};

export default useIsMobile;
